// @ts-check

import { ROUTE_LAYOUT, ROUTE_NAME } from '@/router/meta'
import BaseView from '@/views/BaseView.vue'

/**
 * Creates onboarding route based on the given path and name.
 * @param {string} path
 * @param {string} name
 * @returns {import('vue-router').RouteRecordRaw}
 */
const constructRoute = (path, name) => ({
  path,
  name,
  component: () => import('@/views/onboarding/OnboardingIndex.vue'),
  meta: {
    requiresAuth: true,
    icon: '$account-outline',
    [ROUTE_NAME]: name,
    [ROUTE_LAYOUT]: BaseView
  }
})

export const ONBOARDING_USER = { path: '/setup/user', name: 'setup-user' }

export const ONBOARDING_COMPANY = {
  path: '/setup/company',
  name: 'setup-company'
}

export const ONBOARDING_INDUSTRY = {
  path: '/setup/industry',
  name: 'setup-industry'
}
export const ONBOARDING_TURNOVER = {
  path: '/setup/turnover',
  name: 'setup-turnover'
}
export const ONBOARDING_SUMMARY = {
  path: '/setup/summary',
  name: 'setup-summary'
}

export const ONBOARDING_AUTHENTICATION = {
  path: '/setup/authentication',
  name: 'setup-authentication'
}

export const ONBOARDING_BOOKKEEPING = {
  path: '/setup/bookkeeping',
  name: 'setup-bookkeeping'
}

export const onboardingSubroutes = [
  ONBOARDING_USER,
  ONBOARDING_COMPANY,
  ONBOARDING_INDUSTRY,
  ONBOARDING_TURNOVER,
  ONBOARDING_SUMMARY,
  ONBOARDING_AUTHENTICATION,
  ONBOARDING_BOOKKEEPING
]

export const onboardingRoutes = [
  constructRoute('/setup', 'setup'),
  ...onboardingSubroutes.map((route) => constructRoute(route.path, route.name))
]

export default onboardingRoutes
